import { defineStore } from 'pinia';
import { nextTick } from 'vue';

import { computeUiStatus } from '@/helpers/scrapeUi';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import { ScrapeUiStatus } from '@/enums/ScrapeUiStatus';

export const useScrapeControlStore = defineStore('scrapeControl', {
    /* ------------------------------------------------------------------ */
    /* state                                                               */
    /* ------------------------------------------------------------------ */
    state: () => ({
        isPaused: false,
        allowResume: true,
        activeFetches: 0,
        resetCounter: 0,
    }),

    /* ------------------------------------------------------------------ */
    /* getters                                                             */
    /* ------------------------------------------------------------------ */
    getters: {
        uiStatus(state): ScrapeUiStatus {
            return computeUiStatus(state.isPaused, state.activeFetches);
        },
    },

    /* ------------------------------------------------------------------ */
    /* actions                                                             */
    /* ------------------------------------------------------------------ */
    actions: {
        /* ----- user-facing controls ------------------------------------- */
        pause() {
            this.isPaused = true;
            this.allowResume = true;
        },
        resume() {
            if (this.allowResume) {
                this.isPaused = false;
                this.allowResume = false;
            }
        },
        startFresh() {
            this.isPaused = false;
            this.allowResume = true;
        },

        /** Reset → clear active URL, abort queues, return to Ready state. */
        async reset() {
            useActiveUrlStore().clearActiveUrl();
            this.resetCounter += 1;
            this.isPaused = false;   // Ready
            this.activeFetches = 0;
            this.allowResume = false;
            await nextTick();             // allow watchers to react
        },

        /* ----- internal hooks (used by scrapeFetchService) -------------- */
        startFetch() {
            this.activeFetches += 1;
        },
        finishFetch() {
            this.activeFetches = Math.max(0, this.activeFetches - 1);
        },
    },
});
